const Main = () => import('../../pages/main')
const EnquiryIndex = () => import('../../pages/Enquiry')

export default {
	path: '/enquiry',
	component: Main,
	meta: {
		sideNav: true
	},
	children: [
		{
			name: 'enquiry',
			path: 'index',
			component: EnquiryIndex,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '客服询盘',
				icon: 'icon-nav icon-nav-inquiry'

			}
		}
	]
}
